import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, Target, Users, Award, Clock } from 'lucide-react';
export const AboutUsPage = () => {
  const leadershipTeam = [{
    name: 'Shawn Alahah',
    title: 'Chief Executive Officer',
    bio: 'Shawn brings over 20 years of investment banking and private equity experience. Prior to founding Sapis Capital, he held senior positions at Netgroup Associates and Blackstone Group.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/d9EJQxceYr4C2ejDcWHKt2/kokk.jpg'
  }, {
    name: 'Marcus Chen',
    title: 'Chief Investment Officer',
    bio: 'Marcus oversees all investment activities at Sapis Capital. With a background in strategic consulting and corporate development, he specializes in identifying high-growth opportunities across multiple sectors.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80'
  }, {
    name: 'Sophia Rodriguez',
    title: 'Managing Director, Venture Capital',
    bio: 'Sophia leads our venture capital practice, focusing on early-stage technology investments. She previously founded two successful startups and served as a partner at Sequoia Capital.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1522&q=80'
  }, {
    name: 'Jonathan Park',
    title: 'Managing Director, Private Equity',
    bio: 'Jonathan heads our private equity division with expertise in operational improvements and strategic acquisitions. He previously served as COO for multiple Fortune 500 companies.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80'
  }, {
    name: 'Priya Patel',
    title: 'Managing Director, Real Assets',
    bio: 'Priya manages our real asset investments portfolio, specializing in infrastructure and real estate. She brings 15 years of experience in asset management and property development.',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80'
  }, {
    name: 'David Thompson',
    title: 'Chief Financial Officer',
    bio: 'David oversees financial strategy and operations at Sapis Capital. With a background in investment banking and corporate finance, he ensures our firm maintains strong financial health.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80'
  }];
  const companyValues = [{
    title: 'Integrity',
    description: 'We uphold the highest ethical standards in all our dealings, building trust through transparency and honesty.',
    icon: <Award className="text-[#38b2ac] h-8 w-8" data-id="element-231" />
  }, {
    title: 'Partnership',
    description: 'We believe in collaborative relationships that align interests and create mutual success with our portfolio companies.',
    icon: <Users className="text-[#38b2ac] h-8 w-8" data-id="element-232" />
  }, {
    title: 'Excellence',
    description: 'We pursue exceptional outcomes through disciplined processes, continuous improvement, and unwavering attention to detail.',
    icon: <Target className="text-[#38b2ac] h-8 w-8" data-id="element-233" />
  }, {
    title: 'Long-term Vision',
    description: 'We make decisions with a focus on sustainable growth and enduring value creation, not short-term gains.',
    icon: <Clock className="text-[#38b2ac] h-8 w-8" data-id="element-234" />
  }];
  return <div className="font-sans text-gray-800 bg-white" data-id="element-235">
      <Header data-id="element-236" />
      <main data-id="element-237">
        {/* Hero Section */}
        <section className="relative bg-[#0a2351] text-white pt-20" data-id="element-238">
          <div className="absolute inset-0 z-0 opacity-20" data-id="element-239">
            <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80" alt="Team collaboration" className="w-full h-full object-cover" data-id="element-240" />
          </div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-10" data-id="element-241">
            <div className="max-w-3xl" data-id="element-242">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-243">
                About Sapis Capital
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl" data-id="element-244">
                Building lasting partnerships to create exceptional value
              </p>
              <nav className="flex" aria-label="Breadcrumb" data-id="element-245">
                <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-246">
                  <li className="inline-flex items-center" data-id="element-247">
                    <a href="/" className="text-gray-300 hover:text-white" data-id="element-248">
                      Home
                    </a>
                  </li>
                  <li data-id="element-249">
                    <div className="flex items-center" data-id="element-250">
                      <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-251" />
                      <span className="ml-1 text-white md:ml-2" data-id="element-252">About Us</span>
                    </div>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="h-16 bg-gradient-to-b from-[#0a2351] to-white opacity-20" data-id="element-253"></div>
        </section>
        {/* Mission Statement Section */}
        <section className="py-20 bg-white" data-id="element-254">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-256">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-257">
                Our Mission
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-258"></div>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-259">
              <div className="text-center mb-12" data-id="element-260">
                <p className="text-2xl leading-relaxed text-gray-700 italic" data-id="element-261">
                  "To empower visionary businesses with strategic capital and
                  expertise, fostering sustainable growth and creating lasting
                  value for our partners, investors, and communities."
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-262">
                <p className="text-lg mb-6 leading-relaxed" data-id="element-263">
                  At Sapis Capital, we believe that exceptional businesses
                  deserve more than just financial investment. They need
                  partners who understand their vision, share their values, and
                  can provide the strategic guidance to navigate complex
                  challenges and seize transformative opportunities.
                </p>
                <p className="text-lg mb-6 leading-relaxed" data-id="element-264">
                  Our approach combines disciplined capital allocation with deep
                  operational expertise and industry insights. We work closely
                  with management teams to build resilient companies capable of
                  sustained growth and market leadership.
                </p>
                <p className="text-lg leading-relaxed" data-id="element-265">
                  Beyond financial returns, we measure our success by the
                  positive impact our portfolio companies make in their
                  industries and communities. We're committed to responsible
                  investment practices that create enduring value for all
                  stakeholders.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Leadership Team Section */}
        <section className="py-20 bg-gray-50" data-id="element-266">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-268">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-269">
                Our Leadership Team
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-270"></div>
              <p className="text-xl text-gray-600" data-id="element-271">
                Meet the experienced professionals guiding our investment
                strategy
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-272">
              {leadershipTeam.map((leader, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-273">
                  <div className="h-64 overflow-hidden" data-id="element-274">
                    <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" data-id="element-275" />
                  </div>
                  <div className="p-6" data-id="element-276">
                    <h3 className="text-xl font-semibold mb-1 text-[#0a2351]" data-id="element-277">
                      {leader.name}
                    </h3>
                    <p className="text-[#38b2ac] font-medium mb-4" data-id="element-278">
                      {leader.title}
                    </p>
                    <p className="text-gray-600" data-id="element-279">{leader.bio}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Company Values Section */}
        <section className="py-20 bg-white" data-id="element-280">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-282">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-283">
                Our Values
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-284"></div>
              <p className="text-xl text-gray-600" data-id="element-285">
                The principles that guide our decisions and actions
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-286">
              {companyValues.map((value, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm flex" data-id="element-287">
                  <div className="mr-6 flex-shrink-0" data-id="element-288">{value.icon}</div>
                  <div data-id="element-289">
                    <h3 className="text-xl font-semibold mb-3 text-[#0a2351]" data-id="element-290">
                      {value.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-291">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* History/Timeline Section */}
        <section className="py-20 bg-gray-50" data-id="element-292">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-294">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-295">
                Our Journey
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-296"></div>
              <p className="text-xl text-gray-600" data-id="element-297">
                Key milestones in the Sapis Capital story
              </p>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-298">
              <div className="space-y-12" data-id="element-299">
                <div className="flex flex-col md:flex-row" data-id="element-300">
                  <div className="md:w-1/3" data-id="element-301">
                    <div className="bg-[#0a2351] text-white text-center p-4 rounded-lg md:mr-8 mb-4 md:mb-0" data-id="element-302">
                      <h3 className="font-bold text-xl" data-id="element-303">2011</h3>
                      <p data-id="element-304">Foundation</p>
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-305">
                    <h4 className="text-lg font-semibold text-[#0a2351] mb-2" data-id="element-306">
                      Sapis Capital Founded
                    </h4>
                    <p className="text-gray-600" data-id="element-307">
                      Established with a commitment to responsible investment
                      and long-term value creation, focusing initially on
                      middle-market private equity opportunities.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row" data-id="element-308">
                  <div className="md:w-1/3" data-id="element-309">
                    <div className="bg-[#0a2351] text-white text-center p-4 rounded-lg md:mr-8 mb-4 md:mb-0" data-id="element-310">
                      <h3 className="font-bold text-xl" data-id="element-311">2014</h3>
                      <p data-id="element-312">Expansion</p>
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-313">
                    <h4 className="text-lg font-semibold text-[#0a2351] mb-2" data-id="element-314">
                      Venture Capital Division Launched
                    </h4>
                    <p className="text-gray-600" data-id="element-315">
                      Expanded our investment strategy to include early and
                      growth-stage technology companies, establishing our first
                      dedicated venture fund.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row" data-id="element-316">
                  <div className="md:w-1/3" data-id="element-317">
                    <div className="bg-[#0a2351] text-white text-center p-4 rounded-lg md:mr-8 mb-4 md:mb-0" data-id="element-318">
                      <h3 className="font-bold text-xl" data-id="element-319">2017</h3>
                      <p data-id="element-320">Growth</p>
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-321">
                    <h4 className="text-lg font-semibold text-[#0a2351] mb-2" data-id="element-322">
                      International Offices Opened
                    </h4>
                    <p className="text-gray-600" data-id="element-323">
                      Established presence in key global markets with offices in
                      London, Singapore, and Toronto, enabling us to source
                      opportunities worldwide.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row" data-id="element-324">
                  <div className="md:w-1/3" data-id="element-325">
                    <div className="bg-[#0a2351] text-white text-center p-4 rounded-lg md:mr-8 mb-4 md:mb-0" data-id="element-326">
                      <h3 className="font-bold text-xl" data-id="element-327">2020</h3>
                      <p data-id="element-328">Innovation</p>
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-329">
                    <h4 className="text-lg font-semibold text-[#0a2351] mb-2" data-id="element-330">
                      Real Assets Division Created
                    </h4>
                    <p className="text-gray-600" data-id="element-331">
                      Launched our real assets strategy, focusing on
                      infrastructure and real estate investments that provide
                      stable returns and portfolio diversification.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row" data-id="element-332">
                  <div className="md:w-1/3" data-id="element-333">
                    <div className="bg-[#0a2351] text-white text-center p-4 rounded-lg md:mr-8 mb-4 md:mb-0" data-id="element-334">
                      <h3 className="font-bold text-xl" data-id="element-335">2023</h3>
                      <p data-id="element-336">Present</p>
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-337">
                    <h4 className="text-lg font-semibold text-[#0a2351] mb-2" data-id="element-338">
                      $150M+ Assets Under Management
                    </h4>
                    <p className="text-gray-600" data-id="element-339">
                      Today, Sapis Capital manages over $150 million across
                      diverse investment strategies, with a track record of
                      consistent returns and positive impact.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-340" />
    </div>;
};